<template>
  <div class="leftside-menu">
    <!-- LOGO -->
    <router-link :to="{ path: '/' }" class="logo text-center logo-light"><span class="logo-lg">
        <img :src="logo" alt="Logo" height="60" width="80" /> </span></router-link>

    <div class="h-100 scrollbar-width-thin" style="overflow-y: auto" id="leftside-menu-container" data-simplebar>
      <!--- Sidemenu -->
      <ul class="side-nav crollbar-width-thin">
        <li class="side-nav-item" v-for="route in routes" :key="route.name">
          <a data-bs-toggle="collapse" :href="'#' + route.name" aria-expanded="false" class="side-nav-link"
            v-if="route.children.length > 0">
            <i v-if="route.icon_name" v-bind:class="route.icon_name"></i>
            <span> &nbsp &nbsp{{ route.name }} </span>
            <span class="menu-arrow"></span>
          </a>

          <router-link :to="route.path" class="side-nav-link" v-else>
            <i v-if="route.icon_name" v-bind:class="route.icon_name"></i>
            <span> &nbsp &nbsp{{ route.name }} </span>
          </router-link>

          <div class="collapse" :id="route.name">
            <ul class="side-nav-second-level">
              <li v-for="children in route.children" :key="children.name">
                <router-link :to="children.path">
                  <span class="fa fa-user mr-1"></span> &nbsp
                  {{ children.name }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>
    <!-- Sidebar -left -->
  </div>
</template>
<script>
import { FadeInOut } from "vue3-transitions";
import { mapGetters, mapActions } from "vuex";
import logo from "@/assets/logo.png";
export default {
  name: "NavigationTemplate",
  props: {
    msg: String,
  },
  components: { FadeInOut },
  data() {
    return {
      logo: logo,
      routes: [],
      activeClass: "",
    };
  },
  methods: {},
  computed: {
    computedClass() {
      if (this.currentRouteName == "/pos") {
        return "active";
      } else {
        return "";
      }
    },
    currentRouteName() {
      return this.$route.path;
    },
  },
  mounted() { },
  created() {
    // this.routes = this.$router;
    this.routes = this.$router.options.navigations;
  },
};
</script>
